import { dmApi } from './dmApi';
import { getAuthorizationHeader } from '../helpers/RtkQueryUtils';

const appVersionApi = dmApi.injectEndpoints({
  endpoints: (build) => ({
    getAppVersions: build.query({
      query: (appType = 'laucher') => ({ url: `/captifyversion/releases?appType=${encodeURIComponent(appType)}`, headers: getAuthorizationHeader() }),
      providesTags: ['AppVersions'],
    }),
    createApkUpload: build.mutation({
      query: (body) => ({
        url: '/captifyversion/uploadApk', method: 'POST', headers: getAuthorizationHeader(), body,
      }),
    }),
    deleteAppVersion: build.mutation({
      query: (id) => ({ url: `/captifyversion/releases/${encodeURIComponent(id)}`, method: 'DELETE', headers: getAuthorizationHeader() }),
      invalidatesTags: ['AppVersions'],
    }),
    publishAppVersion: build.mutation({
      query: (body) => ({
        url: '/captifyversion/releases/publish', method: 'POST', headers: getAuthorizationHeader(), body,
      }),
      invalidatesTags: ['AppVersions'],
    }),
  }),
});

export const {
  useGetAppVersionsQuery,
  useCreateApkUploadMutation,
  usePublishAppVersionMutation,
  useDeleteAppVersionMutation,
} = appVersionApi;
